import { render, staticRenderFns } from "./ModalAccountainAction.vue?vue&type=template&id=0f9c2988&scoped=true"
import script from "./ModalAccountainAction.vue?vue&type=script&lang=js"
export * from "./ModalAccountainAction.vue?vue&type=script&lang=js"
import style0 from "./ModalAccountainAction.vue?vue&type=style&index=0&id=0f9c2988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c2988",
  null
  
)

export default component.exports